import api from "PFCore/api";
import { Id } from "PFTypes/id";
import { SkillsFramework } from "PFTypes/skills_framework";

export const fetchSkillsFramework = (id: Id) =>
  api<SkillsFramework>({
    url: `admin/skills_framework/templates/${id}`
  });
